import 'setup/initialize-sentry';
import * as Sentry from '@sentry/browser';
import type { Action, AnyAction, Middleware } from 'redux';
import type { IState } from 'redux/state';
import { pick } from 'utils/typesafe';

const getType = (action: Action | null) => String(action?.type ?? '__NONE__');
const selectStateForSentryError = (state: IState) => {
  return {
    account: pick(
      state?.accounts?.current,
      'id',
      'status',
      'plan_id',
      'plan_name',
      'currency',
      'start_of_week',
      'beta',
      'trial',
      'experiments'
    ),
    global: pick(
      state?.global,
      'isUserOnline',
      'initializedAt',
      'initializedAssetRevision',
      'requestedAssetRevision'
    ),
    user: pick(state?.user, 'id', 'admin', 'time_zone', 'owner', 'time_format'),
    userProperties: pick(state?.user?.properties, 'has_enabled_tic'),
    ticAuth: pick(state?.ticAuth, 'isAuthenticated'),
  };
};

export const createSentryMiddleware = (): Middleware => {
  return store => {
    let lastAction: Action | null = null;

    Sentry.getCurrentScope().addEventProcessor(event => {
      const state = store.getState();

      event.extra = {
        ...event.extra,
        lastAction,
        state: JSON.stringify(selectStateForSentryError(state), null, 2),
      };

      return event;
    });

    return next => action => {
      Sentry.addBreadcrumb({
        category: 'redux-action',
        message: getType(action as AnyAction),
        level: 'info',
        data: undefined,
        timestamp: Date.now() / 1000,
      });

      lastAction = action as AnyAction;
      return next(action);
    };
  };
};
